var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,{tag:"component",staticClass:"control",class:_vm.classObject,on:{"click":_vm.onClick}},[_c('i',{staticClass:"icon"},[(_vm.icon)?_c('i',{staticClass:"icon",class:_vm.icon}):_vm._e()]),_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }